import {
  ExpertSystemHierarchyNode,
  KpiCalculationError,
  Iso8601,
  InstallationStatus,
  User
} from '@hconnect/common/types'

export type HierarchyTableNode = Omit<ExpertSystemHierarchyNode, 'children'> &
  MonthColumns & {
    subItems?: HierarchyTableNode[]
    average?: number
    averageError?: KpiCalculationError
    averageIsDirty?: boolean
    weightedAverage?: number
    weightedAverageError?: KpiCalculationError
    weightedAverageIsPartial?: boolean
  }

export type MonthDataColumns = {
  [key: string]: MonthColumns
}

export type MonthColumns = {
  jan?: MonthData
  feb?: MonthData
  mar?: MonthData
  apr?: MonthData
  may?: MonthData
  jun?: MonthData
  jul?: MonthData
  aug?: MonthData
  sep?: MonthData
  oct?: MonthData
  nov?: MonthData
  dec?: MonthData
}

export type MonthData = {
  value?: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  hasComments?: boolean
}

export enum ExpertSystemEquipmentType {
  Mill = 'mill',
  Kiln = 'kiln'
}

export type HistoricalDialogData =
  | {hierarchyId: string; equipmentName: string; month: string}
  | undefined

export type HierarchyIdParams = {
  areaId?: string
  regionId?: string
  countryId?: string
  plantId?: string
}

export type YearMonth = string // YYYY-MM

export type CommentKpiValue = {
  id: string
  content: string
  author: {
    id: string
    name: string
  }
  createdAt: Iso8601
  modifiedAt: Iso8601
  isDeleted: boolean
  day?: number
}
export type KpiAverageValue = {
  hierarchyId: string
  value?: number
  kpiCalculationError?: string
  isDirty: boolean
}

export type YearlyKpiValue = {
  hierarchyId: string
  year: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  value?: number
}

export type HistoricalKpiValue = {
  value?: number
  kpiCalculationError?: KpiCalculationError
  version: number
  modifiedBy?: User
  modifiedAt: Iso8601
}

export type NewCommentKpi = {
  content: string
  replyToCommentId?: string
  day?: number
}

export type MtmKpiValue = {
  hierarchyId: string
  isEditedManually: boolean
  kpiCalculationError?: KpiCalculationError
  month: string
  isDirty: boolean
  value?: number
  hasComments?: boolean
}

export type WeightedAverageValue = {
  hierarchyId: string
  year: number
  value?: number
  kpiCalculationError?: KpiCalculationError
  isPartial?: boolean
}

export type MtmWithAggregatesResponse = {
  rows: MtmKpiValue[]
  weightedAverages: WeightedAverageValue[]
}

export type KpiUpdate = {
  plantId?: string
  equipmentType?: string
  responsibleUserIds: string[]
  kpiNodes: {
    id?: string
    name: string
    kpiAssignmentId?: number
    millType?: string
    expertSystemName?: string
    upmDepartmentId?: string
    installationStatus?: InstallationStatus | string
    installationStatusText?: string
    installationYear?: number
  }[]
}

export type DailyKpiValue = {
  hierarchyId: string
  value?: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: string
  day: number
  hasComments?: boolean
}

export type MonthlyKpiValue = {
  hierarchyId: string
  value?: number
  isEditedManually: boolean
  isDirty: boolean
  kpiCalculationError?: KpiCalculationError
  month: number
}
